const onComplete = () => ({});

export default onComplete;
